import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";
import type { PaginatedResponse } from "@/types/api";
import { buildUrl } from "@/utils/buildUrl";

import type { InfoProperty, IProperty, PropertyFillterParams } from "./types";

export const propertiesApi = {
  async getAllProperties(
    params?: PropertyFillterParams
  ): Promise<PaginatedResponse<IProperty>> {
    const url = buildUrl(API_ENDPOINTS.ADMIN, "/properties", params);

    const response = await apiClient.get<PaginatedResponse<IProperty>>(url);
    return response;
  },

  async deleteProperty(propertyId: string) {
    const response = await apiClient.delete(
      `${API_ENDPOINTS.ADMIN}/properties/${propertyId}`
    );
    return response;
  },

  async postNewProperty(data: InfoProperty) {
    const response = await apiClient.post<InfoProperty>(
      `${API_ENDPOINTS.ADMIN}/properties`,
      data
    );
    return response;
  },

  async patchProperty(id: string, data: InfoProperty) {
    const response = await apiClient.patch(
      `${API_ENDPOINTS.ADMIN}/properties/${id}`,
      data
    );
    return response;
  },
};
